import React, { useState } from 'react';
import { Table, Tag, Button, Modal, Form, Input, Select, Space, message, Card } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined, TeamOutlined } from '@ant-design/icons';
import { useListClientsQuery, useAddClientMutation, useEditClientMutation, useDeleteClientMutation } from '../store/api';

const { Option } = Select;

const Clientes = () => {
  const { data = [], isLoading } = useListClientsQuery();
  const [addClient] = useAddClientMutation();
  const [editClient] = useEditClientMutation();
  const [deleteClient] = useDeleteClientMutation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();

  const showModal = (record = null) => {
    setEditingRecord(record);
    record ? form.setFieldsValue(record) : form.resetFields();
    setIsModalVisible(true);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (editingRecord?.id) {
        await editClient({ id: editingRecord.id, ...values }).unwrap();
        message.success('Cliente actualizado');
      } else {
        await addClient(values).unwrap();
        message.success('Cliente creado');
      }
      setIsModalVisible(false);
      form.resetFields();
    } catch {
      message.error('Error al guardar cliente');
    }
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: '¿Eliminar este cliente?',
      content: 'Esta acción no se puede deshacer.',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          await deleteClient(id).unwrap();
          message.success('Cliente eliminado');
        } catch {
          message.error('Error al eliminar');
        }
      },
    });
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: 'Nombre', dataIndex: 'nombre', key: 'nombre', render: (t) => <span style={{ fontWeight: 600 }}>{t}</span> },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Teléfono', dataIndex: 'telefono', key: 'telefono' },
    { title: 'Estado', dataIndex: 'estado', key: 'estado', render: s => <Tag color={s === 'Activo' ? 'green' : 'red'} style={{ borderRadius: 12 }}>{s?.toUpperCase()}</Tag> },
    {
      title: 'Acciones', key: 'acciones',
      render: (_, record) => (
        <Space size={4}>
          <button className="action-btn" title="Editar" onClick={() => showModal(record)}><EditOutlined /></button>
          <button className="action-btn" title="Eliminar" onClick={() => handleDelete(record.id)} style={{ color: '#dc3545' }}><DeleteOutlined /></button>
        </Space>
      ),
    },
  ];

  return (
    <div className="page-container fade-in">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title"><TeamOutlined style={{ marginRight: 8 }} />Clientes</h1>
          <div className="page-subtitle">{data.length} clientes registrados</div>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal(null)}
          style={{ borderRadius: 8, fontWeight: 600, background: 'linear-gradient(135deg, #0168fa, #042893)', border: 'none' }}>
          Nuevo Cliente
        </Button>
      </div>

      <Card bordered={false} bodyStyle={{ padding: 0 }}>
        <div className="modern-table">
          <Table columns={columns} dataSource={data} rowKey="id" loading={isLoading}
            pagination={{ pageSize: 10, showTotal: t => `${t} clientes` }} scroll={{ x: true }} size="middle" />
        </div>
      </Card>

      <Modal title={editingRecord ? 'Editar Cliente' : 'Nuevo Cliente'} open={isModalVisible}
        onOk={handleSave} onCancel={() => { setIsModalVisible(false); form.resetFields(); }}
        okText="Guardar" cancelText="Cancelar">
        <Form form={form} layout="vertical">
          <Form.Item name="nombre" label="Nombre" rules={[{ required: true, message: 'Ingrese el nombre' }]}><Input /></Form.Item>
          <Form.Item name="email" label="Email" rules={[{ type: 'email', message: 'Email inválido' }]}><Input /></Form.Item>
          <Form.Item name="telefono" label="Teléfono"><Input /></Form.Item>
          <Form.Item name="estado" label="Estado" initialValue="Activo">
            <Select><Option value="Activo">Activo</Option><Option value="Inactivo">Inactivo</Option></Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Clientes;
